import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {baseUrl} from "../../../../core/constants/base-url";
import {planFactExceptionResourceType} from "../configs/plan-fact-exception-config";
import {PlanFactException} from "../types/release-calendar-types";
import {jsonPathHeaders} from "../../../../core/models/http-headers";

@Injectable({
  providedIn: 'root'
})
export class PlanFactExceptionApiService {
  private http: HttpClient = inject(HttpClient);

  public createPlanFactExceptions({ date, dayLimit, productId }: PlanFactException): Observable<PlanFactException> {
    const newPlanFactExceptions = {
      date: date,
      dayLimit: dayLimit,
      productId: productId
    };

    return this.http.post<PlanFactException>(`${baseUrl}/${planFactExceptionResourceType.path}`, newPlanFactExceptions);
  }

  public updatePlanFactExceptions({ id, dayLimit }: PlanFactException): Observable<PlanFactException> {

    const body = [{
      'op': 'add',
      'path': `/dayLimit`,
      'value': dayLimit,
    }];

    return this.http.patch<PlanFactException>(`${baseUrl}/${planFactExceptionResourceType.path}/${id}`, body, {
      headers: jsonPathHeaders
    });
  }

  public deletePlanFactExceptions(id: number): Observable<void> {
    return this.http.delete<void>(`${baseUrl}/${planFactExceptionResourceType.path}/${id}`);
  }
}
